// extracted by mini-css-extract-plugin
export default {"color":"#1859f1"};